import React from "react";
import { Link } from "react-router-dom";

const SignUpFooterLink = () => {
	return (
		<div className="sign-up-link-container">
			Not yet registered? &nbsp;
			<span className="link-container">
				<Link className="sign-up-link" to="/sign-up">
					Sign up
				</Link>
			</span>
		</div>
	);
};

export default SignUpFooterLink;
